import { useEffect } from 'react';
import { useRouter } from 'next/router';

function CustomerRedirect() {
    const router = useRouter();

    useEffect(() => {
        // Redirect to get-subscription-link page when accessing /customer
        router.replace('/get-subscription-link');
    }, [router]);

    // Return null or a loading state while redirecting
    return null;
}

export default CustomerRedirect;